var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.excel.apply(null, arguments)}}},[_c('i',{staticClass:"icon-download"}),_vm._v(" Excel ")])
}
var staticRenderFns = []

export { render, staticRenderFns }